import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect } from 'react';
import img from './ErrorEmpty_image.png';
import { defaultTitle, defaultText } from './content';
import { Stack } from '@fluentui/react';
/**
 * Premade 404 **component** with a pretty graphic.
 *
 * > Note: Has defaults for children and title, but can be overridden.
 */
export const Default404Component = ({ title = defaultTitle, children = defaultText, }) => {
    useEffect(() => {
        document.title = title;
    }, [title]);
    return (_jsx(_Fragment, { children: _jsxs(Stack, Object.assign({ horizontalAlign: 'center', tokens: { childrenGap: '12px' }, styles: { root: { width: '100%' } } }, { children: [_jsx("img", { src: img, "aria-hidden": 'true', alt: '', style: { padding: '2em 0 2em', maxHeight: '20%' } }), _jsx("h1", { children: title }), _jsx("div", Object.assign({ style: {
                        textAlign: 'center',
                    } }, { children: children }))] })) }));
};
